import { bind } from 'decko'
import { LiveNodeList } from 'live-node-list'
import {
  goToSlide,
  registerSlideshow,
  unregisterSlideshow,
} from './slideshow-helpers'

export default class SlideshowPagination {
  /**
   * @type {LiveNodeList}
   */
  paginationItems = new LiveNodeList('.slideshow-pagination')

  constructor() {
    this.registerListeners()
  }

  registerListeners() {
    this.paginationItems.on('update', (newItems, oldItems) => {
      newItems.forEach(this.registerSlideshow)
      oldItems.forEach(this.unregisterSlideshow)
    })

    this.paginationItems.forEach(this.registerSlideshow)
  }

  @bind
  registerSlideshow(item) {
    const target = document.getElementById(item.getAttribute('aria-controls'))
    registerSlideshow(item, {
      onScroll: this.handleScroll.bind(this, item, target),
      onUpdateChildren: this.createChildren.bind(this, item, target),
    })

    window.addEventListener(
      'resize',
      this.handleResize.bind(this, item, target),
    )
  }

  @bind
  unregisterSlideshow(item) {
    const target = document.getElementById(item.getAttribute('aria-controls'))
    unregisterSlideshow(item, {
      onScroll: this.handleScroll.bind(this, item, target),
      onUpdateChildren: () => {
        this.createChildren(item, target).then(_ => {
          this.handleScroll(item, target)
        })
      },
    })
    window.removeEventListener(
      'resize',
      this.handleResize.bind(this, item, target),
    )
  }

  @bind
  handleResize(item, target, event) {
    clearTimeout(item.resizeCallback)

    item.resizeCallback = setTimeout(() => {
      this.createChildren(item, target).then(_ => {
        this.handleScroll(item, target)
      })
    }, 250)
  }

  @bind
  createChildren(item, target) {
    return new Promise((resolve, reject) => {
      const perPage = window.matchMedia('(min-width: 63.75em)').matches
        ? item.dataset.perPage
        : item.dataset.perPageMobile
      item.innerHTML = ''
      let j = 0
      Array.prototype.forEach.call(target.slides.items, (child, i) => {
        const k = Array.from(target.children).indexOf(child)
        if (i % perPage === 0) {
          const dummy = document.createElement('div')
          dummy.innerHTML = `
                <button class="slideshow-pagination__item" data-index="${k}" aria-label="Go to slide ${j}">
                  <span class="screenreader-text">Go to slide ${j}</span>
                </button>
              `

          const button = dummy.firstElementChild
          button.addEventListener('click', () =>
            goToSlide(target, button.dataset.index),
          )

          item.appendChild(button)

          j++
        }
      })

      item.setAttribute('aria-hidden', (item.children.length <= 1).toString())

      resolve()
    })
  }

  @bind
  handleScroll(item, target, event) {
    const selected = target.querySelector('[aria-current="true"]')
    const index = Array.from(target.children).indexOf(selected)

    const children = Array.from(
      item.querySelectorAll('.slideshow-pagination__item'),
    )

    children.forEach(child => child.setAttribute('aria-current', 'false'))
    let current = children[0]
    for (let child of children) {
      if (parseInt(child.dataset.index) >= index) {
        current = child
        break
      }
    }

    if (current) {
      current.setAttribute('aria-current', 'true')
    }
  }
}
